// Angular
import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// Libs
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
// Components
import { ConfirmModalComponent } from '../../../../shared/components/confirm-modal/confirm-modal.component';
// Models
import { ShoppingCartStatusType } from '@core/enums/shopping-cart-status.enum';
import { ISession } from '@core/models-v2/auth/session.interface';
import {
  IOrderDetail,
  IOrderDetailResponse,
} from '@core/models-v2/cart/order-details.interface';
// Services
import { CartService } from '@core/services-v2/cart.service';
import { SessionService } from '@core/services-v2/session/session.service';
import { TableLazyLoadEvent } from 'primeng/table';
import { QuotationApiService } from '@core/services-v2/quotation/quotation-api/quotation-api.service';
import { SalesOrderApiService } from '@core/services-v2/sales-order/sales-order-api/sales-order-api.service';
import { ScreenService } from '@shared/services/screen';

@Component({
  selector: 'app-page-quotation',
  templateUrl: './page-quotation.component.html',
  styleUrls: ['./page-quotation.component.scss'],
})
export class PageQuotationComponent implements OnInit {
  private readonly screenService = inject(ScreenService);

  isMobile = this.screenService.isMobile;

  modalRef!: BsModalRef;
  loadingData: boolean = true;
  usuario!: ISession;
  orders!: IOrderDetail[];
  totalRows: number = 0;
  rows: number = 10;
  first: number = 0;

  private readonly quotationApiService = inject(QuotationApiService);
  private readonly salesOrderApiService = inject(SalesOrderApiService);

  constructor(
    private toast: ToastrService,
    private modalService: BsModalService,
    private router: Router,
    private cartService: CartService,
    private readonly sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.dataPrimeTable();
  }

  //para tabla de prime ng
  dataPrimeTable(event?: TableLazyLoadEvent) {
    this.usuario = this.sessionService.getSession();
    this.first = event?.first || 0;
    this.rows = event?.rows || this.rows;
    this.loadingData = true;
    if (this.usuario && (this.usuario.username || this.usuario.email)) {
      this.salesOrderApiService
        .getOrderDetails({
          page: this.first / this.rows + 1,
          limit: this.rows,
          user: this.usuario.username
            ? this.usuario.username
            : this.usuario.email,
          salesDocumentType: 1,
          statuses: [ShoppingCartStatusType.GENERATED],
          sort: 'salesId|-1',
        })
        .subscribe((resp: IOrderDetailResponse) => {
          if (resp.data) {
            this.orders = resp.data;
            this.totalRows = resp.total;
            this.loadingData = false;
          }
        });
    } else {
      console.error('el usuario no esta definido o no tiene email');
    }
  }

  convertirACarro(item: IOrderDetail) {
    const initialState = {
      title: 'Cargar productos en carro de compras',
      body: `Se cargarán todos los productos de este presupuesto en el carro de compras, reemplazando el contenido actual.<br/>
                Podrá retomar su carro actual posteriormente.<br>
                  ¿Desea continuar?`,
      textBtnTrue: 'Confirmar',
      textBtnFalse: 'Cancelar',
      callback: (confirm: boolean) => {
        if (confirm) {
          this.quotationApiService
            .toOpenCart(
              item.salesId,
              item.user,
              this.usuario.username ? this.usuario.username : item.user
            )
            .subscribe(() => {
              this.toast.success(
                'Este presupuesto está ahora disponible en su carro de compras.'
              );
              this.cartService.load();
              this.router.navigate(['/carro-compra', 'resumen']);
            });
        } else {
          // console.log('cancelar');
        }
      },
    };

    this.modalRef = this.modalService.show(ConfirmModalComponent, {
      initialState,
    });
  }
}
